/* 
   Pie chart module
*/
import cloneDeep from 'lodash/cloneDeep';
import pieChartConfigBuilder from './pie-chart-config-builder';
import { pieTooltip } from '../../widget-utilities/widget-tooltip';
import d3Utils from '../../../../utils/d3Utils';
import chartUtils from '../../../../utils/chart-utils';

var pieChart = function pieChart() {

    // Resets the slices in pie/doughnut charts
    var resetExplosion = function resetExplosion(containerId, animate) {
        if (animate == null) animate = false;

        var svg = d3.select("#" + containerId).select("svg");
        if (svg == null) return;

        if (svg.length == 0) return;

        if (svg[0] == null) return;

        if (svg[0][0] == null) return;

        var path = svg.selectAll(".slice>path, path.slice, .arc>path");

        if (path.length == 0 || path[0].length == 0) return;

        for (var i = 0; i < path[0].length; i++) {
            var currentPath = d3.select(path[0][i]);

            if (currentPath.attr("exploded") == "0") continue;

            var duration = 250;

            if (!animate) currentPath.attr("transform", "translate(0,0)").attr("exploded", "0");else currentPath.transition().duration(duration).ease("bounce").attr("transform", "translate(0,0)").attr("exploded", "0");
        }
    };

    // Event handler for click events on the pie/doughnut slices
    var pieOnClickHandler = function pieOnClickHandler(parentContainerId) {
        resetExplosion(parentContainerId, true);
        var radius = Number(d3.select("#" + parentContainerId).select("svg").attr("radius"));
        var startAngle = Number(d3.select(this).attr("startangle"));
        var endAngle = Number(d3.select(this).attr("endangle"));
        if (d3.select(this).attr("exploded") == "0") {
            var ang = startAngle + (endAngle - startAngle) / 2;
            ang = (ang - Math.PI / 2) * -1;
            var x = Math.cos(ang) * radius * 0.1;
            var y = Math.sin(ang) * radius * -0.1;
            d3.select(this).transition().duration(250).ease("bounce").attr("transform", "translate(" + x + "," + y + ")").attr("exploded", "1");
        } else d3.select(this).transition().duration(250).ease("bounce").attr("transform", "translate(0,0)").attr("exploded", "0");
    };

    // Render column chart widget
    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            Model = widgetConfig.Model,
            Width = widgetConfig.Width,
            Height = widgetConfig.Height,
            Cloud = widgetConfig.Cloud,
            StampText = widgetConfig.StampText,
            ColorScheme = widgetConfig.ColorScheme,
            Data = widgetConfig.Data,
            ChartConfig = widgetConfig.ChartConfig;


        var el = window.document.querySelector('#' + ContainerId);

        var parentContainerId = ContainerId.includes('flip-') ? ContainerId.split('flip-')[1] : ContainerId;

        //TODO: Check impact of below commented code
        //Hack in focus and blur methods so they don"t fail when a module calls them
        //dom.Element.prototype.blur = function () { };//will need to fire an event for testing
        //dom.Element.prototype.focus = function () { };//will need to fire an event for testing

        //TODO: Add logic
        var CrumbFieldConfig = ChartConfig.CrumbFieldConfig;
        var crumbFieldName = CrumbFieldConfig[Object.keys(CrumbFieldConfig)[0]];
        var crumbDisplayFieldName = ChartConfig.CrumbDisplayFieldName;
        var crumbFormat = {
            'CloudName': Cloud,
            'ModelName': Model,
            'Type': 'Node',
            'Name': Object.keys(CrumbFieldConfig)[0],
            'FieldName': crumbFieldName,
            'Value': '',
            'DisplayFieldName': crumbDisplayFieldName,
            'DisplayValue': null
        };
        var showLegend = ChartConfig.ShowLegend;
        var showValueWithLegend = ChartConfig.ShowValueWithLegend;
        var showLabels = ChartConfig.ShowLabels;
        var showCategoryLabels = ChartConfig.ShowCategoryLabels;
        var doughnut = ChartConfig.Doughnut;
        var showPercentage = ChartConfig.ShowPercentage;
        var totalRecords = ChartConfig.TotalRecords;
        var showDefaultTooltip = ChartConfig.ShowDefaultTooltip;
        var sortCategories = ChartConfig.SortAxis;
        var defaultPerspective = ChartConfig.DefaultPerspective;
        var stampText = StampText;
        var classifierField = ChartConfig.ClassifierField;
        var margin = {
            left: 0.01,
            right: 0.01,
            top: 0.02,
            bottom: 0.02
        };
        var padding = {
            horizontal: 0.02,
            vertical: 0.04
        };
        var legendWidth = 0.15;
        var labelRadius = 1.2;
        var pieHemisphere = Number(chartUtils.pieHemisphere[ChartConfig.PieHemisphere.toLowerCase()]);
        var legendLocation = ChartConfig.LegendLocation;

        var legendRectSize = 0.02;
        var legendSpacing = 0.01;
        var offset = 0.01;

        d3.select(el).select('svg').remove();

        var data = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.data), '\x01', ""));
        var labelFieldName = ChartConfig.XAxisField;
        var valueFieldName = ChartConfig.YAxisFields[0];
        var valueDisplayName = ChartConfig.YAxisNames[0];
        var aggregationType = ChartConfig.AggregationType;

        var accumulationType = aggregationType,
            displayFormat = ChartConfig.ValueFormat,
            currencyPrefix = ChartConfig.CurrencySymbol,
            colorPalette = JSON.parse(chartUtils.replaceAll(JSON.stringify(ChartConfig.ColorPalette), '\x01', "")),
            baseFormat = ChartConfig.BaseFormat;

        if (valueDisplayName == null || valueDisplayName.trim().length == 0) valueDisplayName = valueFieldName;

        if (colorPalette != null && colorPalette.length == 0) colorCount = null;

        var colorCount = colorPalette == null ? 0 : colorPalette.length;
        var colorScheme = JSON.parse(chartUtils.replaceAll(JSON.stringify(ColorScheme), '\x01', ""));

        var width = Number(chartUtils.replaceAll(Width, '\x01', "")),
            height = Number(chartUtils.replaceAll(Height, '\x01', ""));

        var color = d3.scale.category20c();

        if (colorScheme != null && colorScheme.length > 0) color = d3.scale.ordinal().range(colorScheme);

        var x = margin.left;
        var y = margin.top;
        var legendX = showLegend ? x : 0;
        var legendY = showLegend ? y : 0;
        var chartX = showLegend ? Number(legendX) + Number(legendWidth) + Number(padding.horizontal) : x;
        var chartY = y;
        var chartWidth = 1 - chartX - margin.right;
        var chartHeight = 1 - chartY - margin.bottom;

        var tipField = ChartConfig.TipField;
        var tooltipConfig = ChartConfig.Tooltip;

        if (tooltipConfig != null && tooltipConfig.toString().trim().length > 0) tooltipConfig = JSON.parse(chartUtils.replaceAll(JSON.stringify(tooltipConfig), '\x01', ''));

        if (showLegend) {
            switch (legendLocation) {
                case chartUtils.legendLocation.right:
                    {
                        chartX = x;
                        chartWidth = 1 - chartX - margin.right - Number(legendWidth) - Number(padding.horizontal) - Number(legendRectSize);
                        legendX = chartWidth;
                        break;
                    }
                case chartUtils.legendLocation.top:
                    {
                        legendY = margin.top;
                        chartX = x;
                        chartY = margin.top + Number(padding.vertical) + Number(legendRectSize);
                        chartHeight -= Number(padding.vertical) + Number(legendRectSize);
                        break;
                    }
                case chartUtils.legendLocation.bottom:
                    {
                        chartX = x;
                        chartY = margin.top;
                        chartHeight -= Number(padding.vertical) + Number(legendRectSize);
                        legendY = Number(chartHeight) + Number(padding.vertical);
                        break;
                    }
            }
        }

        legendX = chartUtils.makeRelative(legendX, width);
        legendY = chartUtils.makeRelative(legendY, height);
        legendWidth = chartUtils.makeRelative(legendWidth, width);
        legendHeight = chartUtils.makeRelative(legendHeight, height);

        chartX = chartUtils.makeRelative(chartX, width);
        chartY = chartUtils.makeRelative(chartY, height);
        chartWidth = chartUtils.makeRelative(chartWidth, width);
        chartHeight = chartUtils.makeRelative(chartHeight, height);

        var radius = Math.min(chartWidth, chartHeight) / 2;
        radius = showCategoryLabels ? radius * 0.7 : radius;
        var outerRadius = showCategoryLabels ? radius * labelRadius : 0;
        var innerRadius = doughnut ? radius / 1.5 : 0;
        var arc = d3.svg.arc().outerRadius(radius).innerRadius(innerRadius);

        var outerArc = d3.svg.arc().innerRadius(radius * 0.2).outerRadius(outerRadius);

        var svg = d3.select(el).append('svg').attr('width', width).attr('height', height).attr('radius', radius).attr('innerRadius', innerRadius).attr('viewBox', '0 0 ' + width + ' ' + height).attr('preserveAspectRatio', 'xMidYMid').attr('class', 'maximize-trigger');

        var pieX = Number(chartX) + Number(chartWidth) / 2;
        var pieY = Number(chartY) + Number(chartHeight) / 2;

        var pie = d3.layout.pie().value(function (d) {
            return Number(d[valueFieldName]);
        });

        if (pieHemisphere != chartUtils.pieHemisphere.full) {
            pieY = Number(chartY) + Number(chartHeight) - Number(chartHeight) / 3;
            var start = -Math.PI / 2;
            var end = Math.PI / 2;

            if (pieHemisphere == chartUtils.pieHemisphere.bottom) {
                start = 3 * Math.PI / 2;
                pieY = Number(chartY) + Number(chartHeight) / 3;
            }
            pie = pie.startAngle(start).endAngle(end);
        }

        var chart = svg.append('g').attr('transform', 'translate(' + pieX + ',' + pieY + ')');

        var accumulator = [];
        var total = 0;

        for (var i = 0; i < data.length; i++) {
            var dt = data[i];

            if (dt[labelFieldName] == null || dt[valueFieldName] == null) continue;

            var item = {};

            if (classifierField != null && dt[classifierField] != null) item["className"] = chartUtils.makeStyleName(dt[classifierField]);else item["className"] = chartUtils.makeStyleName(dt[labelFieldName]);

            item[labelFieldName] = dt[labelFieldName];
            var name = dt["SeriesName"] == null ? dt["valueFieldName"] : dt["SeriesName"];

            item['tip'] = dt[tipField] == null ? name : dt[tipField] + '<br/>' + name;

            item[valueFieldName] = Math.round(Number(dt[valueFieldName]) * 100) / 100;
            item[crumbFieldName] = dt[crumbFieldName];
            item[crumbDisplayFieldName] = dt[crumbDisplayFieldName];
            item['counter'] = dt['counter'];
            item['valueFieldName'] = dt["valueFieldName"];
            item['value'] = dt[valueFieldName];

            var tooltips = dt["tooltip"];
            if (tooltips != null && tooltipConfig != null && tooltipConfig.TooltipConfigs != null && tooltipConfig.TooltipConfigs.length > 0) for (var index = 0; index < tooltipConfig.TooltipConfigs.length; index++) {
                item[tooltipConfig.TooltipConfigs[index].Id] = tooltips[tooltipConfig.TooltipConfigs[index].Id];
            }accumulator.push(item);
        }

        //Calculate the total
        for (var i = 0; i < accumulator.length; i++) {
            total += accumulator[i][valueFieldName];
        }

        if (sortCategories) {
            chartUtils.sort(accumulator, labelFieldName);
            pie.sort(function (d1, d2) {
                if (d1[labelFieldName] == null || d2[labelFieldName] == null) return;
                var l1 = d1[labelFieldName].toString();
                var l2 = d2[labelFieldName].toString();
                return l1.localeCompare(l2);
            });
        } else chartUtils.sort(accumulator, valueFieldName, null, null, null, true);

        //Select paths, use arc generator to draw
        var arcs = chart.selectAll('g.slice').data(pie(accumulator)).enter().append('svg:g');

        var clockwise = true;
        var initialAngles = {
            startAngle: 0,
            endAngle: 0
        };

        var a = {};
        a.startAngle = clockwise ? 0 : Math.PI * 2;
        a.endAngle = clockwise ? 0 : Math.PI * 2;

        arcs.append('svg:path').attr('class', function (d) {
            if (d.data["className"] != null) return 'slice dataviz editviz ' + d.data["className"];
            return 'slice dataviz editviz';
        }).attr('fill', function (d, i) {
            if (colorPalette != null) {
                var index = i >= colorCount ? i % colorCount : i;
                return colorPalette[index];
            }
            return color(i);
        }).attr('index', function (d, i) {
            return i;
        }).attr('d', function (d) {
            return arc(d);
        }).attr('label', function (d) {
            if (showDefaultTooltip) {
                var defaultTip = '<span class="tip-header">' + d.data.tip + ':</span><span class="tip-value"> ' + chartUtils.format(d.value, displayFormat, currencyPrefix, null, baseFormat) + '</span>';
            }

            var tipText = chartUtils.buildTooltipText(tooltipConfig, d.data, defaultTip, d.data.valueFieldName, accumulationType, totalRecords);

            if (showPercentage) {
                var percentageDisplayFormat = displayFormat != "" ? displayFormat + "%" : ".0f%";
                tipText += '<br /><span class="tip-header">' + d.data.valueFieldName + ' %: </span><span class="tip-value">' + chartUtils.format(d.value / total * 100, percentageDisplayFormat, null, null, null) + '</span>';
            }

            return tipText;
        }).attr('exploded', '0').attr('startangle', function (d) {
            return d.startAngle;
        }).attr('endangle', function (d) {
            return d.endAngle;
        }).attr('id', function (d, i) {
            return 'Slice' + i;
        }).attr('coord', function (d, i) {
            crumbFormat.Value = d.data[crumbFieldName];
            crumbFormat.FieldName = crumbFieldName;
            crumbFormat.DisplayValue = d.data[crumbDisplayFieldName];
            crumbFormat.DisplayFieldName = crumbDisplayFieldName;
            crumbFormat.DefaultPerspective = defaultPerspective;
            return JSON.stringify(crumbFormat);
        }).attr('name', function (d) {
            return d.data["className"];
        }).attr('d', arc(initialAngles)).on("click", function () {
            pieOnClickHandler.call(this, parentContainerId);
        }).on("touchstart", function () {
            pieTooltip.onMouseOver.call(this, parentContainerId);
        }).on("mouseover", function () {
            pieTooltip.onMouseOver.call(this, parentContainerId);
        }).on("mouseout", pieTooltip.onMouseOut).on("touchmove", pieTooltip.onTouchMove).on("mousemove", function () {
            pieTooltip.onMouseMove.call(this, parentContainerId);
        }).transition().delay(500).duration(750).ease('linear').attrTween('d', function (d) {
            var n = { startAngle: d.startAngle, endAngle: d.endAngle };
            var i = d3.interpolate(a, n);
            n = i(0);
            return function (t) {
                return arc(i(t));
            };
        });

        function getMidAngleDegrees(d) {
            return (d.endAngle - d.startAngle) * 180 / Math.PI;
        };

        function getStartAngle(d) {
            return d.startAngle;
        };

        function getEndAngle(d) {
            return d.endAngle;
        };

        function computeSliceAngle(d) {
            var a = (d.startAngle + d.endAngle) * 90 / Math.PI - 90;
            return a;
        };

        var maxValue = d3.max(accumulator, function (d) {
            return Math.round(Number(d[valueFieldName]) * 100) / 100;
        });
        var centroid = void 0,
            midAngle = void 0,
            sign = void 0,
            labelX = void 0;
        var threshold = doughnut ? 15 : 20;
        var outerLabelThreshold = 15;
        if (showCategoryLabels) {
            arcs.append("line").attr({
                x1: function x1(d, i) {
                    return outerArc.centroid(d)[0];
                },
                y1: function y1(d, i) {
                    return outerArc.centroid(d)[1];
                },
                x2: function x2(d, i) {
                    centroid = outerArc.centroid(d);
                    midAngle = Math.atan2(centroid[1], centroid[0]);
                    x = Math.cos(midAngle) * (radius * labelRadius);
                    return x;
                },
                y2: function y2(d, i) {
                    centroid = outerArc.centroid(d);
                    midAngle = Math.atan2(centroid[1], centroid[0]);
                    y = Math.sin(midAngle) * (radius * labelRadius);
                    return y;
                },
                'class': "pie-label-line"
            }).style("opacity", function (d) {
                var a = Number(getMidAngleDegrees(d));
                a = isNaN(a) ? 0 : a;
                a = Math.abs(a);
                if (a < outerLabelThreshold) return 0;
                return 1;
            }).style("stroke", "#000");

            arcs.append("text").attr({
                'transform': function transform(d, i) {
                    centroid = outerArc.centroid(d);
                    midAngle = Math.atan2(centroid[1], centroid[0]);
                    x = Math.cos(midAngle) * (radius * labelRadius);
                    sign = x > 0 ? 1 : -1;
                    labelX = x + 5 * sign;
                    y = Math.sin(midAngle) * (radius * labelRadius);
                    return 'translate(' + labelX + "," + y + ')';
                },
                'text-anchor': function textAnchor(d, i) {
                    centroid = outerArc.centroid(d);
                    midAngle = Math.atan2(centroid[1], centroid[0]);
                    x = Math.cos(midAngle);
                    return x > 0 ? "start" : "end";
                },
                'class': 'pie-label pie-outer-label'
            }).text(function (d) {
                var a = Number(getMidAngleDegrees(d));
                a = isNaN(a) ? 0 : a;
                a = Math.abs(a);
                if (a < outerLabelThreshold) return "";
                // checking for a threshold on label length
                var labelText = d.data[labelFieldName];
                if (labelText.length > 12) labelText = d.data[labelFieldName].substring(0, 12) + "...";
                if (showLabels) labelText += " : " + chartUtils.format(d.value, displayFormat, currencyPrefix, maxValue, baseFormat);
                if (showPercentage) {
                    var percentageDisplayFormat = displayFormat != "" ? displayFormat + "%" : ".0f%";
                    labelText += " : " + chartUtils.format(d.value / total * 100, percentageDisplayFormat, null, null, null);
                }
                return labelText;
            });
        }

        if (showLabels && !showCategoryLabels) {
            var labelArc = d3.svg.arc().outerRadius(radius).innerRadius(radius / 1.5);
            arcs.append('text').attr('transform', function (d) {
                return 'translate(' + labelArc.centroid(d) + ')';
            }).attr('dy', '0.35em').attr('class', 'labels').style('text-anchor', function (d) {
                return 'middle';
            }).text(function (d) {
                var a = Number(getMidAngleDegrees(d));
                a = isNaN(a) ? 0 : a;
                a = Math.abs(a);
                if (a < threshold) return "";
                var actualValue = chartUtils.format(d.value, displayFormat, currencyPrefix, maxValue, baseFormat);
                return actualValue;
            }).attr('class', 'pie-label pie-inner-label').attr("opacity", 0).transition().delay(1000).duration(200).attr("opacity", 1);
        }

        if (showPercentage && !showCategoryLabels) {
            var labelArc = d3.svg.arc().outerRadius(radius).innerRadius(radius / 1.5);
            var yPos = showLabels ? '2em' : '0.35em';
            arcs.append('text').attr('transform', function (d) {
                return 'translate(' + labelArc.centroid(d) + ')';
            }).attr('dy', yPos).attr('class', 'labels').style('text-anchor', function (d) {
                return 'middle';
            }).text(function (d) {
                var a = Number(getMidAngleDegrees(d));
                a = isNaN(a) ? 0 : a;
                a = Math.abs(a);
                if (a < threshold) return "";
                var percentageDisplayFormat = displayFormat != "" ? displayFormat + "%" : ".0f%";
                var percentageValue = chartUtils.format(d.value / total * 100, percentageDisplayFormat, null, null, null);
                return percentageValue;
            }).attr('class', 'pie-label pie-inner-label').attr("opacity", 0).transition().delay(1000).duration(200).attr("opacity", 1);
        }

        var text = null;

        switch (accumulationType) {
            case chartUtils.aggregationTypes.sum:
                text = "Total " + chartUtils.replaceAll(valueDisplayName, "+", " ");
                break;
            case chartUtils.aggregationTypes.count:
                text = "# " + chartUtils.replaceAll(valueDisplayName, "+", " ");
                break;
            case chartUtils.aggregationTypes.average:
                text = "Average " + chartUtils.replaceAll(valueDisplayName, "+", " ");
                break;
            case chartUtils.aggregationTypes.uniqueCount:
                text = "Unique # " + chartUtils.replaceAll(valueDisplayName, "+", " ");
                break;
        };

        var value = chartUtils.format(total, displayFormat, currencyPrefix, maxValue, baseFormat);

        if (doughnut) {
            var textPos = "0em";
            var valuePos = "1.5em";

            if (pieHemisphere == utils.top || pieHemisphere == utils.bottom) {
                textPos = "-1.5em";
                valuePos = "0em";
            }

            chart.append("text").attr("dy", textPos).style("text-anchor", "middle").attr("class", "pie-inner-label pie-total-label").text(text);

            chart.append("text").attr("dy", valuePos).style("text-anchor", "middle").attr("class", "pie-inner-label pie-total-label").text(value);
        }

        //Add the total as svg's bread crumb
        svg.attr("total", value);

        if (showLegend) {
            var legendItems = [];
            var legendItem = {};

            for (var index = 0; index < accumulator.length; index++) {
                if (Number(accumulator[index][valueFieldName]) <= 0) continue;

                legendItem = {};
                legendItem['index'] = index;
                legendItem['data'] = accumulator[index];

                legendItems.push(legendItem);
            }

            legendRectSize = chartUtils.makeRelative(legendRectSize, width);

            legendSpacing = chartUtils.makeRelative(legendSpacing, height);

            offset = chartUtils.makeRelative(offset, height);

            var legendHeight = Number(legendItems.length) * (Number(legendRectSize) + Number(legendSpacing) + Number(offset));

            var legendSectionWidth = (width - Number(chartX) - margin.right * width) / Number(legendItems.length);

            if (legendLocation == chartUtils.legendLocation.left || legendLocation == chartUtils.legendLocation.right) legendY = height / 2 - legendHeight / 2;

            var legendContainer = svg.append('g');
            legendContainer.attr('transform', 'translate(' + legendX + ',' + legendY + ')');

            var legend = legendContainer.selectAll(".legend").data(legendItems).enter().append("g").attr("class", function (d) {
                if (d.data["className"] != null) return "legend";

                return "legend";
            }).attr("transform", function (d, i) {
                var itemHeight = Number(legendRectSize) + Number(legendSpacing);
                var horz = 0;
                var vert = i * Number(itemHeight) + Number(offset);

                if (legendLocation == chartUtils.legendLocation.top || legendLocation == chartUtils.legendLocation.bottom) {
                    horz = Number(chartX) + i * (Number(legendRectSize) + Number(legendSpacing) + legendSectionWidth);

                    vert = 0;
                }

                return "translate(" + horz + "," + vert + ")";
            }).on("click", function () {
                var e = d3.event;
                var selector = d3.select(e.target).attr("selector");
                var event = document.createEvent('MouseEvents');
                event.initMouseEvent('click');
                var target = $(".slice." + selector);
                for (i = 0; i < target.length; i++) {
                    target[i].dispatchEvent(event);
                }e.stopPropagation();
                e.preventDefault();
            });

            legend.append('rect').attr('width', legendRectSize).attr('height', legendRectSize).attr('class', function (d) {
                return d.data["className"];
            }).attr('selector', function (d) {
                return d.data["className"];
            }).style('fill', function (d, i) {
                if (colorPalette != null) {
                    var index = i >= colorCount ? i % colorCount : i;

                    return colorPalette[index];
                }

                return color(i);
            });

            legend.append("text").attr("x", Number(legendRectSize) + Number(legendSpacing)).attr("y", legendRectSize / 2).style('text-anchor', 'start').style('dominant-baseline', 'central').attr('class', function (d) {
                return d.data["className"];
            }).attr('selector', function (d) {
                return d.data["className"];
            }).text(function (d) {
                if (showValueWithLegend) var text = d.data[labelFieldName] + " - " + chartUtils.format(d.data[valueFieldName], displayFormat, currencyPrefix, maxValue, baseFormat);else var text = d.data[labelFieldName];

                if (labelFieldName.toLowerCase().indexOf('month') > -1) text = chartUtils.toMonthName(d.data[labelFieldName]);

                return text;
            });
        }

        if (stampText != null && stampText.trim().length > 0) {
            var stampTextContainer = svg.append('g');

            var rectWidth = width / 1.5;
            var rectHeight = 80;

            stampTextContainer.append("foreignObject").attr("x", 0).attr("y", 0).attr("width", rectWidth).attr("height", rectHeight).append("xhtml:body").html("<p class='stampText'>" + stampText + "</p>");
        }
    };

    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {

        // Get widget specific widgetConfig
        var widgetConfig = pieChartConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        renderWidget: renderWidget,
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default pieChart();